module.exports = __webpack_public_path__ + "static/media/CTLI_7-444w.99b9a8ec.webp";